(() => {
  const message = document.currentScript.dataset.error;
  const selector = '.gpo-app textarea[name="Custom Engraving"], .gpo-app textarea[name="Gravurtext"]';
  const logoSelector = '.gpo-app input[type="file"][name="Custom Logo"], .gpo-app input[type="file"][name="Eigenes Logo"]';
  const observedFields = new WeakSet();
  const clear = field => {
    field.setCustomValidity('');
    field.removeAttribute('aria-invalid');
    const note = field.parentElement.querySelector('[data-fm-engraving-error]');
    if (note) note.textContent = '';
  };
  const reveal = field => {
    const details = field.closest('details');
    if (details && !details.open) details.open = true;
  };
  const validate = (form, event) => {
    if (!form || !form.closest('.filamelt-product')) return;
    const field = form.querySelector(selector);
    if (!field) return;
    observeDisabled(field, clear);
    if (field.disabled) { clear(field); return; }
    if (field.value.trim()) { clear(field); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    field.setCustomValidity(message);
    field.setAttribute('aria-invalid', 'true');
    let note = field.parentElement.querySelector('[data-fm-engraving-error]');
    if (!note) {
      note = document.createElement('p');
      note.id = field.id + '-fm-error';
      note.dataset.fmEngravingError = '';
      note.setAttribute('role', 'alert');
      field.after(note);
      const describedBy = field.getAttribute('aria-describedby') || '';
      field.setAttribute('aria-describedby', (describedBy + ' ' + note.id).trim());
    }
    note.textContent = message;
    reveal(field);
    field.focus();
    field.reportValidity();
  };
  const uploadedLogoExists = field => {
    const wrapper = field.closest('.gpo-element') || field.parentElement;
    return [...wrapper.querySelectorAll('a[href]')].some(link => {
      try { return new URL(link.href, location.href).pathname.includes('/uploads/'); }
      catch { return false; }
    });
  };
  const clearLogo = field => {
    field.setCustomValidity('');
    field.removeAttribute('aria-invalid');
    const note = field.closest('.gpo-element')?.querySelector('[data-fm-logo-error]');
    if (note) note.remove();
  };
  const observeDisabled = (field, cleaner) => {
    if (!field || observedFields.has(field)) return;
    observedFields.add(field);
    new MutationObserver(() => {
      if (field.disabled) cleaner(field);
    }).observe(field, { attributes: true, attributeFilter: ['disabled'] });
  };
  const validateLogo = (form, event) => {
    if (!form || !form.closest('.filamelt-product')) return;
    const field = form.querySelector(logoSelector);
    if (!field) return;
    observeDisabled(field, clearLogo);
    if (field.disabled) { clearLogo(field); return; }
    if (uploadedLogoExists(field)) { clearLogo(field); return; }

    event.preventDefault();
    event.stopImmediatePropagation();
    const wasRequired = field.required;
    field.required = true;
    const requiredMessage = field.validationMessage || 'Please select a file.';
    field.required = wasRequired;
    field.setCustomValidity(requiredMessage);
    field.setAttribute('aria-invalid', 'true');
    const wrapper = field.closest('.gpo-element') || field.parentElement;
    let note = wrapper.querySelector('[data-fm-logo-error]');
    if (!note) {
      note = document.createElement('p');
      note.dataset.fmLogoError = '';
      note.setAttribute('role', 'alert');
      wrapper.append(note);
    }
    note.textContent = requiredMessage;
    reveal(field);
    field.focus();
    field.reportValidity();
  };
  const clearInactiveFields = form => {
    if (!form) return;
    const textField = form.querySelector(selector);
    const logoField = form.querySelector(logoSelector);
    observeDisabled(textField, clear);
    observeDisabled(logoField, clearLogo);
    if (textField?.disabled) clear(textField);
    if (logoField?.disabled) clearLogo(logoField);
  };
  window.addEventListener('click', event => {
    const button = event.target.closest?.('button[name="add"], input[type="submit"][name="add"]');
    if (button) {
      validate(button.form, event);
      if (!event.defaultPrevented) validateLogo(button.form, event);
    }
  }, true);
  window.addEventListener('submit', event => {
    validate(event.target, event);
    if (!event.defaultPrevented) validateLogo(event.target, event);
  }, true);
  window.addEventListener('input', event => {
    if (event.target.matches?.(selector)) clear(event.target);
    if (event.target.matches?.(logoSelector)) clearLogo(event.target);
    clearInactiveFields(event.target.form);
  }, true);
  window.addEventListener('change', event => {
    if (event.target.matches?.(logoSelector)) clearLogo(event.target);
    clearInactiveFields(event.target.form);
  }, true);
})();

